// src/config/contract.ts
// Contract configuration for blockchain lootbox transactions

// Contract ABI for the lootbox game
export const LOOTBOX_CONTRACT_ABI = [
  {
    inputs: [
      { internalType: "string", name: "gameId", type: "string" },
      { internalType: "string", name: "action", type: "string" },
      { internalType: "uint256", name: "value", type: "uint256" },
      { internalType: "uint256", name: "randomNums", type: "uint256" },
      { internalType: "uint256", name: "maxInt", type: "uint256" },
    ],
    name: "recordActionWithRandom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "player",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "gameId",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "action",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "randomNumbers",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "GameActionWithRandom",
    type: "event",
  },
] as const;

//reemplazar por el contrato del box
export const LOOTBOX_CONTRACT_ADDRESS =
  (import.meta.env.VITE_LOOTBOX_CONTRACT_ADDRESS as `0x${string}`) ||
  "0x983B499181A1B376CEE9Ffe18984cF62A767f745";

// configuracion holiday box
export const HOLIDAY_HARVEST_CONFIG = {
  gameId: "holiday-harvest",
  action: "open",
  value: BigInt(0),
  randomNums: BigInt(1),
  maxInt: BigInt(1000),
};

// reemplazar
export const HARKAN_API_BASE =
  import.meta.env.VITE_SERVER_URL || "https://api.harkan.io";
